function SinglePostToc() {
  const copyToClipboard = (value) => {
    if (!value) {
      return Promise.reject();
    }

    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    const temporaryInput = document.createElement('input');

    temporaryInput.value = value;
    temporaryInput.setAttribute('readonly', '');
    temporaryInput.style.position = 'fixed';
    temporaryInput.style.top = '-1000px';
    temporaryInput.style.opacity = '0';

    document.body.appendChild(temporaryInput);
    temporaryInput.select();
    temporaryInput.setSelectionRange(0, temporaryInput.value.length);

    const copied = document.execCommand('copy');

    document.body.removeChild(temporaryInput);

    return copied ? Promise.resolve() : Promise.reject();
  };

  const setCopyStatus = (copyLink, message) => {
    const shareBlock = copyLink.closest('.single-post-share');
    const status = shareBlock ? shareBlock.querySelector('[data-share-copy-status]') : null;

    copyLink.classList.add('is-copied');
    copyLink.setAttribute('aria-label', message);

    if (status) {
      status.textContent = message;
      status.classList.add('is-visible');
    }

    window.setTimeout(() => {
      copyLink.classList.remove('is-copied');

      if (status) {
        status.textContent = '';
        status.classList.remove('is-visible');
      }
    }, 2200);
  };

  document.querySelectorAll('[data-share-copy]').forEach((copyLink) => {
    copyLink.addEventListener('click', (event) => {
      event.preventDefault();

      const url = copyLink.getAttribute('href');

      copyToClipboard(url)
        .then(() => setCopyStatus(copyLink, 'Copied!'))
        .catch(() => setCopyStatus(copyLink, 'Copy failed'));
    });
  });

  document.querySelectorAll('[data-share-window]').forEach((shareLink) => {
    shareLink.addEventListener('click', (event) => {
      const url = shareLink.getAttribute('href');

      if (!url) {
        return;
      }

      event.preventDefault();

      const width = 640;
      const height = 520;
      const left = Math.max((window.screen.width - width) / 2, 0);
      const top = Math.max((window.screen.height - height) / 2, 0);
      const features = [
        `width=${width}`,
        `height=${height}`,
        `left=${left}`,
        `top=${top}`,
        'noopener',
        'noreferrer',
      ].join(',');

      window.open(url, 'single-post-share', features);
    });
  });

  const toc = document.querySelector('.single-post-page__toc');
  const links = toc ? [...toc.querySelectorAll('.single-post-page__toc-link')] : [];

  if (!toc || !links.length) {
    return;
  }

  const linkById = new Map();
  const headings = links
    .map((link) => {
      const id = link.hash ? decodeURIComponent(link.hash.slice(1)) : '';
      const heading = id ? document.getElementById(id) : null;

      if (id && heading) {
        linkById.set(id, link);
        return heading;
      }

      return null;
    })
    .filter(Boolean);

  if (!headings.length) {
    return;
  }

  const setActiveLink = (id) => {
    links.forEach((link) => {
      const isActive = linkById.get(id) === link;
      const item = link.closest('.single-post-page__toc-item');

      link.classList.toggle('is-active', isActive);
      link.setAttribute('aria-current', isActive ? 'true' : 'false');

      if (item) {
        item.classList.toggle('is-active', isActive);
      }
    });
  };

  const getCurrentHeadingId = () => {
    const offset = window.innerHeight * 0.32;
    const currentHeading = headings.reduce((current, heading) => {
      const rect = heading.getBoundingClientRect();

      if (rect.top <= offset) {
        return heading;
      }

      return current;
    }, headings[0]);

    return currentHeading.id;
  };

  const updateActiveLink = () => {
    window.requestAnimationFrame(() => {
      setActiveLink(getCurrentHeadingId());
    });
  };

  setActiveLink(getCurrentHeadingId());

  if (!('IntersectionObserver' in window)) {
    window.addEventListener('scroll', updateActiveLink, { passive: true });
    window.addEventListener('resize', updateActiveLink);
    return;
  }

  const observer = new IntersectionObserver(updateActiveLink, {
    rootMargin: '-20% 0px -68% 0px',
    threshold: 0,
  });

  headings.forEach((heading) => {
    observer.observe(heading);
  });

  window.addEventListener('resize', updateActiveLink);
}

export default SinglePostToc;
